import React from 'react';
import { ThemeProvider, CssBaseline, Box, Typography } from '@mui/material';
import { NotificationProvider } from './hooks/useNotification';
import Notification from './components/Notification';
import { useNotification } from './hooks/useNotification';
import theme from './theme';

const AppContent = () => {
  const { notification, hideNotification } = useNotification();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography variant="h2">
          Dolphin Anty Manager
        </Typography>
      </Box>
      <Notification
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App; 